module.exports = __webpack_public_path__ + "img/ai_yuyin.2b1de517.jpg";